import { repositoryInjectionKey } from '../repositories/index';
import {
    createNamedRepository,
    type NamedRepository,
} from '../repositories/named';
import { type InjectionKey, inject } from 'vue';

export function usePartialRepository(
    injectionKey?:
        | string
        | symbol
        | InjectionKey<NamedRepository>
        | null
        | undefined
): NamedRepository {
    const repository = inject(injectionKey ?? repositoryInjectionKey, null);
    if (!repository)
        console.warn(
            'NO PARTIAL REPOSITORY FOUND! for injectionKey: "',
            injectionKey,
            '". An empty repository is used instead...'
        );
    return repository ?? createNamedRepository();
}
